import { GetStaticProps, GetStaticPaths } from 'next';
import { PostPage } from '@components';
import { getAllPostSlugs } from '@api';
import { getStaticPropsCore } from '@/src/getStatic/getStaticPropsCore';

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { slug: string }>>[0]) => {
  console.info(`getStaticProps /blog/${params?.slug}`);
  return await getStaticPropsCore(params?.slug || '');
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: (await getAllPostSlugs({ where: { categoryNotIn: ['356'] } })).map(
      (slug) => `/knowledge/blog/${slug}`
    ),
    fallback: 'blocking',
  };
};

export default PostPage;
